import React from 'react';
import { useEditorStore } from './editor-store';
import { Block } from './types';
import { useTransition, animated, SpringConfig, easings } from '@react-spring/web';
import classNames from 'classnames';
import { BlockControlPanel } from './block-control-panel';

const FLOAT_ANIMATION_CONFIG: SpringConfig = {
  mass: 1,
  tension: 400,
  friction: 40,
};

export const BlockControlPanelContainer = () => {
  const selectedBlockId = useEditorStore((state) => state.selectedBlockId);
  const sections = useEditorStore((state) => state.layout.sections);
  const data = sections.flatMap((section) => section.blocks.filter((block) => block.id === selectedBlockId));

  const [transitions, api] = useTransition<Block, { y: number; opacity: number }>(data, () => ({
    key: (item: Block) => item.id,
    from: (item: Block) => {
      return {
        y: 8,
        opacity: 0,
      };
    },
    enter: (item: Block) => {
      return {
        y: 0,
        opacity: 1,
        config: FLOAT_ANIMATION_CONFIG,
      };
    },
    leave: (item: Block) => {
      return {
        y: 0,
        opacity: 0,
        config: { duration: 200, easing: easings.easeOutCubic },
      };
    },
  }));

  React.useEffect(() => {
    api.start();
  }, [selectedBlockId]);

  return (
    <>
      {transitions((style, item) => (
        <div
          className={classNames('absolute -translate-x-full -left-2 top-1/2 -translate-y-1/2 !z-[200] pointer-events-none', {
            'z-neue-block-control-panel-selected': selectedBlockId === item.id,
            'z-neue-block-control-panel-unselected': selectedBlockId !== item.id,
          })}
        >
          <animated.div style={style} className='pointer-events-none'>
            <BlockControlPanel block={item} />
          </animated.div>
        </div>
      ))}
    </>
  );
};

export const MemoizedBlockControlPanelContainer = React.memo(BlockControlPanelContainer);
